import React, { useState, useEffect } from "react";
import {
  FaLaptopCode,
  FaPalette,
  FaBoxes,
  FaQuoteLeft,
  FaTools,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "../styles/Home.css";
import service1 from "../assets/images/web.jpg";
import service2 from "../assets/images/flyer.webp";
import package1 from "../assets/images/packages.jpg";
import testimonial1 from "../assets/images/testimonial1.jpg";
import testimonial2 from "../assets/images/testimonial2.jpg";
import flyerPreview from "../assets/images/Ulterspace.png";
import About from "./About";
import hero1 from "../assets/images/hero/hero7.jpg";
import hero2 from "../assets/images/hero/hero5.jpg";
import hero3 from "../assets/images/hero/hero8.jpg";
import hero4 from "../assets/images/hero/hero4.jpg";
import video from "../assets/video/hero-video.mp4";

const slides = [
  { type: "image", src: hero1 },
  { type: "image", src: hero2 },
  { type: "video", src: video },
  { type: "image", src: hero3 },
  { type: "image", src: hero4 },
];

function Home() {
  const [index, setIndex] = useState(0);
  // const navigate = useNavigate();

  // Auto slide
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const [filter, setFilter] = useState("All");

  const projects = [
    {
      name: "Mo'Acress Lifestyle",
      img: require("../assets/images/moacress.jpg"),
      url: "https://moacress.co.za",
      category: "Web",
    },
    {
      name: "Machad Farm",
      img: require("../assets/images/FarmLogo.jpg"),
      url: "https://machadfarming.vercel.app/",
      category: "Web",
    },
    {
      name: "Flenny Scent",
      img: require("../assets/images/flennyscent logo.jpg"),
      url: "https://flennyscents1.vercel.app/",
      category: "Graphic",
    },
    {
      name: "Global Automations",
      img: require("../assets/images/Global Automations.png"),
      url: "https://globalautomations.vercel.app/",
      category: "Technical Support",
    },
  ];

  const filteredProjects =
    filter === "All"
      ? projects
      : projects.filter((project) => project.category === filter);

  return (
    <div className="home">
      <section className="hero">
        {/* 🎥 Background Video */}
        <video autoPlay muted loop preload="auto" className="video-bg">
          <source src={video} type="video/mp4" />
        </video>

        {/* 🖼️ Overlay Slider */}
        {/* <div
        className="slider"
        style={{ backgroundImage: `url(${slides[index]})` }}
      /> */}
        <div className="slider">
          {slides[index].type === "image" ? (
            <img src={slides[index].src} alt="slide" />
          ) : (
            <video
              key={index}
              autoPlay
              muted
              loop
              playsInline
              className="slide-video"
            >
              <source src={slides[index].src} type="video/mp4" />
            </video>
          )}
        </div>
        <div className="hero-content">
          <h1>Empower Your Business with Modern IT Solutions</h1>
          <p>Website Design, Branding, Company Profiles & More</p>
          <Link to="/services" className="cta-button">
            Get a Quote
          </Link>
        </div>
      </section>
      <section className="intro fadeIn">
        <div className="intro-header">
          <FaTools className="highlight-icon" />
          <h2>What We Do</h2>
        </div>
        <p className="intro-description">
          We specialize in <strong>web design & development</strong>,{" "}
          <strong>branding</strong>, and{" "}
          <strong>digital identity solutions</strong>. From building websites to
          designing business cards, company profiles, flyers, and logos — we
          bring your ideas to life with creativity and precision.
        </p>
      </section>

      <section className="highlights">
        <Link to="/services" className="highlight-link-wrapper">
          <div className="highlight-box">
            <img src={service1} alt="Web Development" />
            <FaLaptopCode className="highlight-icon" />
            <h3>Web Development</h3>
            <p>Responsive websites tailored to your business goals.</p>
            <span className="highlight-btn">Explore</span>
          </div>
        </Link>
        <Link to="/services" className="highlight-link-wrapper">
          <div className="highlight-box">
            <img src={service2} alt="Graphic Design" />
            <FaPalette className="highlight-icon" />
            <h3>Graphic Design</h3>
            <p>Business cards, flyers, company profiles, and logos.</p>
            <span className="highlight-btn">View Designs</span>
          </div>
        </Link>
        <Link to="/packages" className="highlight-link-wrapper">
          <div className="highlight-box">
            <img src={package1} alt="Custom Packages" />
            <FaBoxes className="highlight-icon" />
            <h3>Custom Packages</h3>
            <p>Flexible pricing & solutions for startups to enterprises.</p>
            <span className="highlight-btn">See Packages</span>
          </div>
        </Link>
      </section>
      <section className="flyer-section">
        <div className="flyer-content">
          <div className="flyer-text">
            <h2>Grab Our Company Flyer</h2>
            <p>
              Download our beautifully crafted flyer to showcase our services.
              Perfect for presentations, meetings, and sharing with clients.
            </p>
            <a href="/Ulterspace.pdf" download className="flyer-download-btn">
              Download Flyer
            </a>
          </div>
          <div className="flyer-image">
            <img src={flyerPreview} alt="Flyer Preview" />
          </div>
        </div>
      </section>

      <section className="work-showcase">
        <h2 className="section-title">
          WORK SHOWCASE<span className="dot"></span>
        </h2>

        <div className="filter-menu">
          {["All", "Web", "Technical Support", "Graphic"].map((cat) => (
            <button
              key={cat}
              className={`filter ${filter === cat ? "active" : ""}`}
              onClick={() => setFilter(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="portfolio-grid">
          {filteredProjects.map((project, index) => (
            <div className="portfolio-item" key={index}>
              <a href={project.url} target="_blank" rel="noopener noreferrer">
                <img src={project.img} alt={project.name} />
              </a>
            </div>
          ))}
        </div>
      </section>
      <About />
      <section className="testimonials">
        <h2>What Our Clients Say</h2>
        <div className="testimonial-box">
          <img src={testimonial2} alt="Client 2" />
          <div className="testimonial-content">
            <FaQuoteLeft className="quote-icon" />
            <p>
              "Professional service, creative solutions, and fast delivery.
              Everything a business needs!"
            </p>
            <strong>- Mark R., Business Owner</strong>
          </div>
        </div>
        <div className="testimonial-box">
          <img src={testimonial1} alt="Client 1" />
          <div className="testimonial-content">
            <FaQuoteLeft className="quote-icon" />
            <p>
              "This team transformed our business with an incredible website and
              branding package. Highly recommend!"
            </p>
            <strong>- Jane M., Startup Founder</strong>
          </div>
        </div>
      </section>
      <section className="project-start-cta">
        <div className="cta-content">
          <h2>
            LET'S GET YOUR PROJECT <br />
            <span className="highlight">STARTED.</span>
          </h2>
          <Link to="/contact" className="cta-button-advanced">
            Contact With Us
          </Link>
        </div>
      </section>
    </div>
  );
}

export default Home;
